import {
  Drupal_Node,
  Drupal_ParagraphExtraTranslations,
  Maybe,
  Drupal_Entity
} from '../generated/graphql';

interface Node extends Drupal_Node {
  fieldExtraTranslations?: {
    entity: Drupal_ParagraphExtraTranslations;
  };
}

const combineEntityTranslations = (
  primary?: Maybe<Drupal_Entity>[] | null,
  secondary?: Maybe<Drupal_Entity>[] | null
) => {
  const existingLangs = (primary || []).map(
    entity => entity?.entityLanguage?.id
  );

  return (primary || []).concat(
    (secondary || []).filter(
      entity => !existingLangs.includes(entity?.entityLanguage?.id)
    )
  );
};

export const getEntityFields = (node: Node) => {
  const { entityMetatags, entityTranslations, fieldExtraTranslations } = node;
  let newEntityTranslations;
  if (fieldExtraTranslations) {
    const {
      fieldPreferReferenceTranslati,
      fieldTranslationNode
    } = fieldExtraTranslations.entity;
    if (fieldTranslationNode?.entity) {
      const referenceEntityTranslations =
        fieldTranslationNode.entity.entityTranslations || [];

      newEntityTranslations = fieldPreferReferenceTranslati
        ? combineEntityTranslations(
            referenceEntityTranslations,
            entityTranslations
          )
        : combineEntityTranslations(
            entityTranslations,
            referenceEntityTranslations
          );
    }
  }

  const combinedTranslations =
    newEntityTranslations || entityTranslations || [];

  return {
    entityMetatags,
    // we have to cast this to Drupal_Node to include the extra fields
    // that are added in the query based on Drupal_Node values
    entityTranslations: combinedTranslations as Drupal_Node[]
  };
};
